import { Outlet } from 'react-router'

const OfficeAssetsLayout = () => {
  return (
    <Outlet />
  )
}

export default OfficeAssetsLayout